export const ItemTypes = { ITEM: 'item' };
